import { Injectable } from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {throwError} from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class HandleErrorService {

  constructor() { }

  catchHttpError(error: HttpErrorResponse): any {
    if (error.status === 500) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: '¡Ocurrió un error!, comunícate con soporte técnico para evaluarlo...',
        confirmButtonText: 'Aceptar',
      });
    } else if ( error.status === 400) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Intenta llenar todos los campos nuevamente!',
        confirmButtonText: 'Aceptar',
      });
    } else if ( error.status === 412) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.error,
        confirmButtonText: 'Aceptar',
      });
    } else if ( error.status === 404) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.error,
        confirmButtonText: 'Aceptar',
      });
    }
    return throwError(error);
  }
}
